import { TagService } from "@/services/tag/tag.service";

export const useTags = (workspaceId: string) => {
  const { data, error, isLoading, mutate } = TagService.getTagsByWorkspaceId(
    workspaceId,
  );

  return {
    tags: data,
    error,
    isLoading,
    mutate,
  };
};
